import { defineStore } from 'pinia'
import { ref } from 'vue'
import {
  getBalanceActivity,
  getSpendingActivity,
  getFullActivity
} from '@/api/dashboards'

export const useWidgetsStore = defineStore('widgets', () => {
  // State
  const balanceActivity = ref<{ [periodId: string]: any }>({})
  const spendingActivity = ref<Record<number, any[]>>({})
  const fullActivity = ref<Record<number, any[]>>({})

  // Actions
  const setInfo = (data: any) => {
    balanceActivity.value = data
  }

  const setSpendingActivity = (periodId: number, data: any[]) => {
    spendingActivity.value[periodId] = data
  }

  const setFullActivity = (adType: number, data: any[]) => {
    fullActivity.value[adType] = data
  }

  const BalanceActivity = async () => {
    const response = await getBalanceActivity()
    setInfo(response.result)
  }

  const SpendingActivity = async (periodId: number) => {
    if (spendingActivity.value[periodId] != null) {
      return
    }

    const response = await getSpendingActivity(periodId)
    setSpendingActivity(periodId, response.result)
  }

  const FullActivity = async (adType: number) => {
    if (fullActivity.value[adType] != null) {
      return
    }

    const response = await getFullActivity(adType)
    setFullActivity(adType, response.result)
  }

  return {
    // State
    balanceActivity,
    spendingActivity,
    fullActivity,

    // Actions
    BalanceActivity,
    SpendingActivity,
    FullActivity
  }
})
